module.exports = __webpack_public_path__ + "img/andreas.39a0c5ff.png";